var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.5C23.8705 10.2261 23.5819 10.9146 23.155 11.516L14.372 23.336C14.0935 23.6958 13.7369 23.9875 13.3291 24.1891C12.9213 24.3907 12.473 24.4969 12.0181 24.4997C11.5631 24.5025 11.1135 24.4018 10.7033 24.2052C10.293 24.0086 9.93285 23.7213 9.65 23.365L0.824 11.3C0.44908 10.7567 0.184413 10.1452 0.045 9.5H6.313L11.066 21.859C11.1383 22.0481 11.2663 22.2108 11.4331 22.3255C11.5999 22.4403 11.7976 22.5017 12 22.5017C12.2024 22.5017 12.4001 22.4403 12.5669 22.3255C12.7337 22.2108 12.8617 22.0481 12.934 21.859L17.687 9.5H24ZM17.7 7.5H23.957C23.8049 6.82341 23.513 6.18611 23.1 5.629L20.542 2.175C20.1716 1.65726 19.6831 1.23525 19.117 0.943959C18.551 0.652667 17.9236 0.500477 17.287 0.500002H15.087L17.7 7.5ZM11.108 0.500002L8.449 7.5H15.561L12.955 0.500002H11.108ZM6.31 7.5L8.968 0.500002H6.646C6.01478 0.499381 5.39242 0.648527 4.83005 0.935189C4.26768 1.22185 3.78135 1.63785 3.411 2.149L0.938 5.391C0.464805 6.01103 0.143545 6.73336 0 7.5H6.31ZM15.544 9.5H8.456L12 18.714L15.544 9.5Z",
    fill: "#05BF8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/Logo3.0a56f78fead602f0d54c55ddcdf7e616.svg";
export { ForwardRef as ReactComponent };